import { Flex, Radio } from '@aws-amplify/ui-react'
import React, { ChangeEventHandler } from 'react'

export default function OptionRadio({ correctIndices, index, onChange }: { index: number, correctIndices: (number | null)[] | null | undefined, onChange: ChangeEventHandler<HTMLInputElement> | undefined }) {
    return <Flex color='white'><b>{String.fromCharCode(65 + index)}</b><Radio  value={String.fromCharCode(65 + index)} checked={correctIndices?.includes(index)} onChange={onChange} /></Flex>
}

